<script lang="ts">
  import type { UserData } from "@anyways-open/identity-api-client";
  import { onMount } from "svelte";
  import { appManager } from "../../AppManagerStore";
  import { _, locale } from "svelte-i18n";

  let data: UserData;

  let email: string = "";

  onMount(async () => {
    data = await $appManager.IdentityApi.getCurrentUser();

    email = data.email;
  });
</script>

<header class="bg-dark pt-9 pb-11 d-none d-md-block">
  <div class="container-md">
    <div class="row align-items-center">
      <div class="col">
        <h1 class="fw-bold text-white mb-2">{$_("users.settings.header.title")}</h1>

        <p class="fs-lg text-white-75 mb-0">
          {$_("users.settings.header.for")} <a class="text-reset" href="mailto:{email}">{email}</a>
        </p>
      </div>
      <div class="col-auto">
        <a class="btn btn-sm btn-gray-300-20" href="{$appManager.PublicUrl}signout">{$_("menu.signout")}</a>
      </div>
    </div>
  </div>
</header>
